import { render } from "./MyActivitiesCardConfigDialog.vue?vue&type=template&id=fefaa070&scoped=true"
import script from "./MyActivitiesCardConfigDialog.vue?vue&type=script&lang=js"
export * from "./MyActivitiesCardConfigDialog.vue?vue&type=script&lang=js"

import "./MyActivitiesCardConfigDialog.vue?vue&type=style&index=0&id=fefaa070&lang=scss&scoped=true"
import "./MyActivitiesCardConfigDialog.vue?vue&type=style&index=1&id=fefaa070&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fefaa070"]])

export default __exports__